package dev.terrakok.mapitan.domain

import kotlinx.browser.window

actual fun getAppUri(): String = window.location.run { "$origin$pathname$search" }
